<template>
    <div class="statement-filters">
        <div class="statement-filters-container">
            <h2>{{ $t('Поиск по операциям') }}</h2>

            <div class="form-group">
                <input type="text" :class="{'form-control': true, 'is-invalid': hasError('description')}" v-model="filters.description" :placeholder="$t('Поиск по операциям')">
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('description')">{{ getError('description') }}</span>

            <div class="form-group">
                <multiselect v-model="filters.category" :options="categories" label="name" track-by="id" class="form-control mt-5">
                    <template slot="singleLabel" class="signle-lable" slot-scope="props">
                        <div class="label">
                            <span>{{ props.option.name }}</span>
                        </div>
                    </template>
                    <template slot="caret">
                        <div class="caret">
                            <i class="icon icon-chevron-down"></i>
                        </div>
                    </template>
                    <template slot="placeholder">
                        <div class="placeholder">
                            <span>{{ $t('Все категории') }}</span>
                        </div>
                    </template>
                </multiselect>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('category')">{{ getError('category') }}</span>

            <div class="form-group">
                <multiselect v-model="filters.account" :multiple="true" :options="accounts" :custom-label="nameWithBalance" label="title" track-by="id" class="form-control">
                    <template slot="singleLabel" class="signle-lable" slot-scope="props">
                        <div class="label">
                            <span>{{ props.option.title }}</span>
                        </div>
                    </template>
                    <template slot="caret">
                        <div class="caret">
                            <i class="icon icon-chevron-down"></i>
                        </div>
                    </template>
                    <template slot="placeholder" slot-scope="props">
                        <div class="placeholder">
                            <span>{{ $t('Все счета') }}</span>
                        </div>
                    </template>
                </multiselect>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('account')">{{ getError('account') }}</span>

            <div class="form-group">
                <multiselect v-model="filters.datePeriod" :searchable="false" :options="periods" label="name" track-by="key" class="form-control">
                    <template slot="singleLabel" class="signle-lable" slot-scope="props">
                        <div class="label">
                            <span>{{ props.option.name }}</span>
                        </div>
                    </template>
                    <template slot="caret">
                        <div class="caret">
                            <i class="icon icon-chevron-down"></i>
                        </div>
                    </template>
                    <template slot="placeholder" slot-scope="props">
                        <div class="placeholder">
                            <span>{{ $t('За все время') }}</span>
                        </div>
                    </template>
                </multiselect>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('period')">{{ getError('period') }}</span>

            <div class="datepicker-group filter-period-group" v-if="filters.period == 'custom'">
                <div class="datepicker-block">
                    <label>{{ $t('От') }}:</label>
                    <date-picker v-model="filters.date_from" :config="datePickerOptions"></date-picker>
                </div>
                <div class="datepicker-block">
                    <label>{{ $t('До') }}:</label>
                    <date-picker v-model="filters.date_to" :config="datePickerOptions"></date-picker>
                </div>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('date_from')">{{ getError('date_from') }}</span>
            <span class="invalid-feedback d-block" v-if="hasError('date_to')">{{ getError('date_to') }}</span>

            <div class="category-controls">
                <div class="checkbox-group mr-32">
                    <input id="new-expenses-check" v-model="filters.outcomes" type="checkbox">
                    <label for="new-expenses-check" class="checkbox-label">
                        {{ $t('расходы') }}
                    </label>
                </div>
                <div class="checkbox-group">
                    <input id="new-incomes-check" v-model="filters.incomes" type="checkbox">
                    <label for="new-incomes-check" class="checkbox-label">
                        {{ $t('доходы') }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import datePicker from 'vue-bootstrap-datetimepicker';
import { EventBus } from '../../../event-bus';

export default {
    name: "StatementFilters",

    components: {
        datePicker,
    },

    props: ['isSideForm'],

	data: function() {
        return {
            filters: {
                description: null,
                category: null,
                category_id: null,
                account: null,
                account_id: null,
                time: null,
                outcomes: true,
                incomes: true,
                datePeriod: null,
                period: null,
                date_from: null,
                date_to: null,
                page: 1,
                per_page: 50,
            },

            datePickerOptions: {
                format: 'DD.MM.YYYY',
                useCurrent: true,

                icons: {
                    previous: 'icon icon-chevron-left',
                    next: 'icon icon-chevron-right',
                }
            },
            
            periods: [
                {
                    name: this.$t('За сегодня'),
                    key: 'today',
                },
                {
                    name: this.$t('Последние 24 часа'),
                    key: '24h',
                },
                {
                    name: this.$t('Последние 7 дней'),
                    key: '7d',
                },
                {
                    name: this.$t('Текущая неделя'),
                    key: 'week',
                },
                {
                    name: this.$t('Последние 30 дней'),
                    key: '30d',
                },
                {
                    name: this.$t('Текущий месяц'),
                    key: 'month',
                },
                {
                    name: this.$t('Последние 180 дней'),
                    key: '180d',
                },
                {
                    name: this.$t('Текущий год'),
                    key: 'year',
                },
                {
                    name: this.$t('Последние 365 дней'),
                    key: '365d',
                },
                {
                    name: this.$t('Выбрать дату'),
                    key: 'custom',
                },
            ],

            errors: {},
        };
    },

    mounted() {
        this.loadCategories();
        this.loadAccounts();

        this.loadWithFilters();
    },

    watch: {
        "filters.description": function(newVal, oldVal) {
            this.filters.page = 1;

            this.$ga.event('loadStatement', 'filters', 'description');

            this.loadWithFilters();
        },
        "filters.category": function(newVal, oldVal) {
            if(newVal === undefined || newVal === null) {
                this.filters.category_id = null;
            } else {
                this.filters.category_id = newVal.id;
            }

            this.filters.page = 1;
            
            this.$ga.event('loadStatement', 'filters', 'category');

            this.loadWithFilters();
        },
        "filters.account": function(newVal, oldVal) {
            if(newVal === undefined || newVal === null) {
                this.filters.account_id = null;
            } else {
                this.filters.account_id = newVal.id;
            }

            this.filters.page = 1;

            this.$ga.event('loadStatement', 'filters', 'account');
            
            this.loadWithFilters();
        },
        "filters.time": function(newVal, oldVal) {
            this.filters.page = 1;

            this.$ga.event('loadStatement', 'filters', 'time');
            
            this.loadWithFilters();
        },
        "filters.outcomes": function(newVal, oldVal) {
            this.filters.page = 1;

            this.$ga.event('loadStatement', 'filters', 'outcomes');
            
            this.loadWithFilters();
        },
        "filters.incomes": function(newVal, oldVal) {
            this.filters.page = 1;
            
            this.$ga.event('loadStatement', 'filters', 'incomes');
            
            this.loadWithFilters();
        },
        "filters.datePeriod": function(newVal, oldVal) {
            if(newVal === undefined || newVal === null) {
                this.filters.period = null;
            } else {
                this.filters.period = newVal.key;
            }

            this.filters.page = 1;
            
            this.$ga.event('loadStatement', 'filters', 'period');

            this.loadWithFilters();
        },
        "filters.date_from": function(newVal, oldVal) {
            this.filters.page = 1;
            
            this.$ga.event('loadStatement', 'filters', 'date_from');

            this.loadWithFilters();
        },
        "filters.date_to": function(newVal, oldVal) {
            this.filters.page = 1;
            
            this.$ga.event('loadStatement', 'filters', 'date_to');

            this.loadWithFilters();
        },
    },

    computed: {
        ...mapGetters(['categories', 'transactions', 'accounts']),

        filteredCategories: function() {
            return this.categories.filter((category) => {
                if(this.filters.outcomes == true && category.expenses) {
                    return true;
                }

                if(this.filters.incomes == true && category.incomes) {
                    return true;
                }

                return false;
            });
        },
    },

    methods: {
        ...mapActions(['loadCategories', 'loadTransactions', 'loadAccounts']),

        nameWithBalance({ title, amount, currency }) {
            let balance = this.$options.filters.money(amount);

            return `${title} — ${balance} ${currency}`;
        },

        loadWithFilters() {
            this.loadTransactions({filters: this.filters});
        },

        hasError(name) {
            return this.errors[name] !== undefined;
        },
        
        getError(name) {
            if(this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }

            return "";
        },
    }
}
</script>

<style scoped lang="scss">
.statement-filters {
    @media (max-width: 768px) {
        display: none;
    }

    .statement-filters-container {
        background: #fff;
        width: calc(100% - 64px);
        border-radius: 5px;
        margin-bottom: 24px;
        padding: 24px 32px;

        @media (max-width: 768px) {
            // background: transparent;
            // padding: 0 24px;
            width: calc(100% - 64px);
            display: flex;
            flex-direction: column;
            height: 100%;

            .btn-form {
                margin-top: auto;
                margin-bottom: 24px;
            }
        }

        h2 {
            color: #152640;
            font-family: "Proxima Nova Lt";
            font-weight: 600;
            font-size: 18px;
            margin: 0;
            margin-bottom: 24px;
        }

        input.form-control {
            width: calc(100% - 24px);
        }

        .form-group {
            .multiselect {
                margin-top: 10px;
            }
        }

        .filter-period-group {
            display: flex;

            .datepicker-block {
                display: flex;
                align-items: center;

                margin-right: 10px;

                &:last-child {
                    margin-right: 0;
                }

                label {
                    margin-right: 5px;
                    font-weight: normal;
                }
            }
        }

        .category-controls {
            display: flex;
            align-items: center;
            flex-direction: row;
            margin: 24px 0 0;
        }
    }
}
</style>